import { GroupEditMode } from "@/Administration/Models/UI/Group/GroupEditMode";
import { IGroupTabModel } from "@/Administration/Models/UI/Group/IGroupTabModel";
import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import { TextboxControl } from "@/Common/Components/Inputs/TextboxControl";
import { Popup } from "@/Common/Components/Modals/Popup";
import { ServiceComboDefinitionModel } from "@/Common/Models/Services/ServiceComboDefinitionModel";
import { ServiceDefinitionModel } from "@/Common/Models/Services/ServiceDefinitionModel";
import { EmployeeGroupUIModel } from "@/Common/Models/UI/Employee/EmployeeGroupUIModel";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { ClickableTextImportation } from "../Users/ClickableTextImportation";
import { UserAddNewServiceComboComponent } from "../Users/UserAddNewServiceComboComponent";
import { GroupDetailsPanelComponent } from "./GroupDetailsPanelComponenet";
import { GroupSearchComponent } from "./GroupSearchComponent";

interface IGroupAdminTabProps {
    groupTabModel: IGroupTabModel;
    serviceDefinitionCache: Immutable.List<ServiceDefinitionModel>;
    serviceComboDefinitionCache: Immutable.List<ServiceComboDefinitionModel>;
}
class GroupAdminTabState {
    public editedGroup: EmployeeGroupUIModel;
}

class GroupAdminTab extends React.Component<IGroupAdminTabProps, GroupAdminTabState> {
    public componentDidUpdate(): void {
        $(window).trigger("resize");
    }

    public componentDidMount(): void {
        let group = this.props.groupTabModel.get("SelectedGroup");
        let groupMode: GroupEditMode = this.props.groupTabModel.get("GroupEditMode");
        if (group != null && groupMode == GroupEditMode.View)
            sessionStore.dispatch(LocalOperations.AdministrationGroup.GetGroupInfo, { GroupId: group.Model.Id });

        $(window).trigger("resize");
    }

    public render(): JSX.Element {
        return (
            <div className="fxheight">
                <div className="admin-users-container">
                    {this.props.groupTabModel.get("SearchMenuOpen") === true && (
                        <GroupSearchComponent
                            model={administrationStore.groupTabModel}
                            operation={LocalOperations.AdministrationGroup.GetAllGroupSearch}
                            selectedGroup={this.props.groupTabModel.get("SelectedGroup")}
                        />
                    )}
                    {this.props.groupTabModel.get("IsCreateNewGroupPopupOpen") === true && (
                        <Popup cssClass="centered-popup width-400" title={cacheStore.GetString("AddNewGroupLabel")} closeTarget={LocalOperations.AdministrationGroup.CloseCreateNewGroupPopup}>
                            <div className="p-body">
                                <div> Please name the new group</div>
                                <TextboxControl
                                    className="form-control"
                                    onChange={value => this.mutateState(() => {
                                        sessionStore.dispatch(LocalOperations.AdministrationGroup.OnChangeGroupName, { GroupName: value });
                                    })}
                                    style={{ maxWidth: "350px", margin: "10px" }}
                                />
                            </div>
                            <div className="p-footer">
                                <div className="col-lg-12 col-md-12 col-sm-12 columns flex-display flex-gap-xs flex-end">
                                    <ButtonControl
                                        className="btn btn-default"
                                        onClick={() => sessionStore.dispatch(LocalOperations.AdministrationGroup.CloseCreateNewGroupPopup)}
                                        label={cacheStore.GetString("CancelLabel")}
                                    />
                                    <ButtonControl
                                        variant="brand"
                                        disabled={IsNullOrWhiteSpace(this.props.groupTabModel.get("GroupName")) ? true : false}
                                        onClick={() => this.createNewGroup()}
                                        label={cacheStore.GetString("ContinueLabel")}
                                    />
                                </div>
                            </div>
                        </Popup>
                    )}

                    {this.props.groupTabModel.get("IsRenameGroupPopupOpen") === true && (
                        <Popup cssClass="centered-popup width-400" title={cacheStore.GetString("RenameGroupLabel")} closeTarget={LocalOperations.AdministrationGroup.IsRenameGroupPopupOpen}>
                            <div className="p-body">
                                <div> {cacheStore.GetString("EditGroupNameMessageLabel")}</div>
                                <TextboxControl
                                    className="form-control"
                                    onChange={value => this.mutateState(() => {
                                        sessionStore.dispatch(LocalOperations.AdministrationGroup.OnChangeGroupName, { GroupName: value });
                                    })}
                                    style={{ maxWidth: "350px", margin: "10px" }}
                                    value={this.props.groupTabModel.get("GroupName")}
                                />
                            </div>
                            <div className="p-footer">
                                <div className="col-lg-12 col-md-12 col-sm-12 columns flex-display flex-gap-xs flex-end">
                                    <ButtonControl
                                        onClick={() => sessionStore.dispatch(LocalOperations.AdministrationGroup.IsRenameGroupPopupOpen)}
                                        label={cacheStore.GetString("CancelLabel")}
                                        className="btn btn-default"
                                    />
                                    <ButtonControl
                                        disabled={IsNullOrWhiteSpace(this.props.groupTabModel.get("GroupName")) ? true : false}
                                        onClick={() => this.changeGroupName()}
                                        label={cacheStore.GetString("ContinueLabel")}
                                        variant="brand"
                                    />
                                </div>
                            </div>
                        </Popup>
                    )}

                    {this.props.groupTabModel.get("IsOpenAddNewServiceCombo") === true && (
                        <UserAddNewServiceComboComponent
                            serviceComboGridModel={this.props.groupTabModel.get("UserServiceComboGridModel")}
                            editedGroup={this.props.groupTabModel.get("EditedGroup")}
                            userServiceComboGridModel={this.props.groupTabModel.get("UserServiceComboGridModel")}
                            serviceDefinitionCache={this.props.serviceDefinitionCache}
                            serviceComboDefinitionCache={this.props.serviceComboDefinitionCache}
                            refreshServiceOperation={LocalOperations.AdministrationGroup.RefreshServices}
                            closeOperation={LocalOperations.AdministrationGroup.AddUserServiceComboPopupClose}
                            saveOperation={LocalOperations.AdministrationGroup.SaveNewServicesCombo}
                            closeSearchSettingOperation={LocalOperations.AdministrationGroup.SearchSettings_Close}
                            openSearchSettingOperation={LocalOperations.AdministrationGroup.SearchSettings_Open}
                        />
                    )}

                    {this.props.groupTabModel.get("IsImportClickableTextOpen") === true && (
                        <ClickableTextImportation
                            clickableTextItems={this.props.groupTabModel.get("GroupClickableTextItems")}
                            groupsTabModel={this.props.groupTabModel}
                            tab={this.props.groupTabModel.get("SelectedTabImportClickableText")}
                            isGroupMode={true}
                        />
                    )}

                    <div className="aside-handle responsive" onClick={() => this.toggleSearchMenu()}> <div className="slide-menu-icon blue d"><span /><span /><span /></div></div>

                    <GroupDetailsPanelComponent
                        model={administrationStore.groupTabModel}
                    />

                </div>
            </div>
        );
    }

    private mutateState(mutation: (s: GroupAdminTabState) => void, then: () => void = null): void {
        var s = new GroupAdminTabState();
        mutation(s);
        this.setState(s, then);
    }

    private toggleSearchMenu(): void {
        sessionStore.dispatch(LocalOperations.AdministrationGroup.ToggleGroupSearchSideBar);
    }

    private createNewGroup(): void {
        let allGroup = this.props.groupTabModel.get("SearchGroupResult");
        let newName = this.props.groupTabModel.get("GroupName");
        if (allGroup.some(x => x.Model.Name.toLowerCase() == newName.toLowerCase())) {
            sessionStore.showPopup({
                title: cacheStore.GetString("WarningLabel"),
                content: cacheStore.GetString("alreadySelectedGroupNameLabel")
            });
        }
        else
            sessionStore.dispatch(LocalOperations.AdministrationGroup.IsEditGroupDetailsSetting);
    }

    private changeGroupName(): void {
        let allGroup = this.props.groupTabModel.get("SearchGroupResult");
        let newName = this.props.groupTabModel.get("GroupName");
        if (allGroup.some(x => x.Model.Name.toLowerCase() == newName.toLowerCase())) {
            sessionStore.showPopup({
                title: cacheStore.GetString("WarningLabel"),
                content: cacheStore.GetString("alreadySelectedGroupNameLabel")
            });
        }
        else
            sessionStore.dispatch(LocalOperations.AdministrationGroup.RenameGroupName);
    }
}

export { GroupAdminTab };
